var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9218(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9218",
    "data-name": "Group 9218",
    transform: "translate(-283 -95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(283 95)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(292 71.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3388",
    "data-name": "Grupo 3388",
    transform: "translate(0 36.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3778",
    "data-name": "Trazado 3778",
    d: "M89.578,56.527l-1.289-1.289a.933.933,0,0,0-1.337,0l-7.586,7.586-3.088-3.083a.933.933,0,0,0-1.337,0l-1.286,1.289a.933.933,0,0,0,0,1.337L78.7,67.408a.933.933,0,0,0,1.337,0l9.544-9.544a.933.933,0,0,0,0-1.337Z",
    transform: "translate(-70.361 -54.193)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9218);
export default __webpack_public_path__ + "static/media/Group 9218.25b93372f9b81b1d23bcbed31222e4ee.svg";
export { ForwardRef as ReactComponent };